import * as React from 'react';
import { useEffect, useState} from 'react';
import { upperCase, map, noop} from 'lodash';
import "./NavBar.css"
import { useDimensions } from 'react-dimensions-hook'
import logo from "../../Assets/Images/iiwtvlogo.png"
import { useMediaQuery } from '@material-ui/core';
import { FaHome, FaSearch, FaTv, FaUser, FaBars } from 'react-icons/fa';
import { BiPlayCircle} from 'react-icons/bi'
import { MenuController } from '../../Managers/Menu';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs'
import Collapse from '@material-ui/core/Collapse';
import { SearchBar } from '../SearchBar/SearchBar';
import { useContext } from 'react';
import { SettingsContext } from '../../Context';
import { Link, useHistory, useLocation } from 'react-router-dom'
import { HistoryTwoTone } from '@material-ui/icons';


export const NavBar = () => {

const history =  useHistory()

const goHome = () => {
    history.push("/")
}
return(
    <NavBarContainer>
        <div className="nav-spread">
                <img src={logo}  onClick={goHome} alt="logo"/>
            <NavItems />
        </div>
    </NavBarContainer>
)
}

type NavBarContainerProps = {
    children: any
}

export const NavBarContainer = (props: NavBarContainerProps) => {

    const [opacity, setOpacity] = useState(0);
    const [height, setHeight] = useState(40);
    const [activeMobile, setActiveMobileMenu] = useState(false)
    const [value, setValue] = useState("")


    const { children }  = props
    useEffect(() => {
        window.addEventListener("scroll", () => {
            const y = window.scrollY
            if(y < 200){
                setOpacity(y / 200)
                setHeight( 60 - (y  / 10))
            } else {
                setOpacity(1)
            }
        })
        return () => window.removeEventListener("scroll", console.log)
    },[])

    const leaving = new Subject<void>()
    useEffect(() => {

        MenuController.get()
        .pipe(takeUntil(leaving))
        .subscribe(setActiveMobileMenu)
        return () => leaving.next()
        
    }, [])

    let {ref} = useDimensions()
    const breakpoint = useMediaQuery('(min-width:768px)')

    return(
        <nav style={{position: 'fixed', zIndex: 1000}}>
            <div 
                ref={ref} 
                style={{height:  breakpoint ? height : 40}}
                className={"nav-container"}
                >
                <div 
                    className="transition nav-background"
                    style={{opacity: breakpoint ? opacity : 1}}>
                </div>
                <div id={"navbar"} >  
                    {children}    
                </div>
            </div>  
 
            <Collapse in={!!activeMobile }>
                <div id="mobile-menu">
                    <SearchBar 
                        value={value}
                        mobile
                        onChange={setValue}
                        placeholder={"Search It Is Written"} 
                        navigate={true}
                        />
                    <NavMobileCategory 
                        title={"browse"} 
                        setActiveMobileMenu={setActiveMobileMenu}
                        items={[
                            {
                                title: "All Programs",
                                link: "/programs",
                            },
                            {
                                title: "Watch Live",
                                link: "/live"
                            },
                            {
                                title: "Spanish",
                                action: noop
                            },
                            {
                                title: "Schedule",
                                action: noop
                            },
                            {
                                title: "My List",
                                action: noop
                            },
                            {
                                title: "Ways to Watch",
                                action: noop
                            }
                        ]}
                    />
                    <NavMobileCategory 
                        setActiveMobileMenu={setActiveMobileMenu}
                        title={"account"} 
                        items={[
                            {
                                title: "Log In",
                                action: noop
                            }
                        ]}
                    />
                    <NavMobileCategory 
                        setActiveMobileMenu={setActiveMobileMenu}
                        title={"About Us"} 
                        items={[
                            {
                                title: "About",
                                action: noop
                            },
                            {
                                title: "Contact",
                                link:"/contact",
                            },
                            {
                                title: "Donate",
                                action: noop
                            },
                            {
                                title: "Help",
                                action: noop
                            },
                        ]}
                    />
                    <NavMobileCategory 
                        setActiveMobileMenu={setActiveMobileMenu}
                        title={"More from it is written"} 
                        items={[
                            {
                                title: "It Is Written",
                                link:"https://itiswritten.com",
                                external: true
                            },
                            {
                                title: "Escrito Está",
                                link:"https://escritoesta.org",
                                external: true
                            },
                            {
                                title: "Donate",
                                link:"https://itiswritten.com/donate",
                                external: true
                            },
                            {
                                title: "Help",
                                link:"https://itiswritten.com/help",
                                external: true
                            },
                        ]}
                    />
                </div>
            </Collapse>                   
        </nav>
    )
}

type NavMobileCategoryProps = {
    title: string
    items: any[]
    footer?: boolean,
    setActiveMobileMenu?: any
}

export const NavMobileCategory = (props: NavMobileCategoryProps) => {
    const { title, items, footer, setActiveMobileMenu} = props
    return(
        <div 
            className="nav-mobile-category-section"
            style={footer ? {
                marginRight: "2em"
            } : {}}
            >
            <NavMobileCategoryTitle title={title} footer={footer} />
            <NavMobileCategoryItems items={items} footer={footer} setActiveMobileMenu={setActiveMobileMenu}/>
        </div>
    )
}


type NavMobileCategoryTitleProps = {
    title: string,
    footer?: boolean
}

const NavMobileCategoryTitle = (props: NavMobileCategoryTitleProps) => {
    const { title, footer } = props
    return(
        <div 
            className="nav-mobile-category-header"
            style={footer ? {
                borderBottom: "none",
                width: "auto",
                fontSize: "1em", 
            } : {}}
            >
            {}
            {title}
        </div>
    )
}

type NavMobileCategoryItem = {
    title: string
    action?: () => {},
    link?: string,
    footer?: boolean,
    external?: boolean
}

type NavMobileCategoryItemsProps = {
    items: any[]
    footer?:boolean,
    setActiveMobileMenu:any,
}

const NavMobileCategoryItems = (props: NavMobileCategoryItemsProps) => {
    const { items, footer, setActiveMobileMenu } = props

    const renderItems = () => {
        return(
            map(items, (item: NavMobileCategoryItem, i: number) => {

                const process = () => {
                    if(!!item?.action){
                        if(!!setActiveMobileMenu) {
                            setActiveMobileMenu(false)
                        }
                        item.action()
                    }
                }

                return (
                    <div 
                        key={`eofllzxkzcviwoe-${i}`}
                        className={"nav-mobile-category-item"}
                        style={footer ? {
                            minWidth: "0",
                        }: {}}
                        onClick={item?.action ? process : null}
                    >
                        {!!item?.link 
                            ? item?.external 
                                ? <a href={item.link} target="_blank" style={{textDecoration: "none", color: "white"}}>{item.title}</a>
                                :<Link to={{pathname: `${item.link}`}} style={{textDecoration: "none", color: "white"}} onClick={() => setActiveMobileMenu?.(false)}>{item.title}</Link> 
                            : item.title
                        }
                        
                    </div>
                )
            })
        )
    }

    return(
        <div className={items.length > 4 && !footer ? "nav-mobile-category-items" : ""} >
            {renderItems()}
        </div>
    )
}

const NavItems = () => {

    const { locale } = useContext(SettingsContext)
    return(
        <div style={{height: '100%'}}>
            <div className="nav-element-list">
                <Link to={"/home"} style={{textDecoration: 'none'}}><NavElement title={locale.home} icon={<FaHome />} /></Link>
                <Link to={"/search"}  style={{textDecoration: 'none'}}><NavElement title={locale.search} icon={<FaSearch />} /></Link>
                <Link to={"/live"}  style={{textDecoration: 'none'}}><NavElement title={locale.live} icon={<FaTv />} /></Link>
                <Link to={"/programs"}  style={{textDecoration: 'none'}}><NavElement title={locale.programs} icon={<BiPlayCircle />} /></Link>
                <NavElement title={locale.login} icon={<FaUser />} />
            </div>
            <div className="nav-center">
                <NavMenu />
            </div>
        </div>
    )
}

type NavElementProps = {
    title: string
    icon: JSX.Element
}

const NavElement = (props: NavElementProps) => {
    const { title, icon } = props
    
    return (
        <div className={"nav-element-container"}>
            {icon}
            <span className="nav-title">{upperCase(title)}</span>
        </div>
    )
}

const NavMenu = () => {

    const [active, setActive] = useState(false)
    const leaving = new Subject<void>()
    useEffect(() => {
        MenuController.get()
        .pipe(takeUntil(leaving))
        .subscribe(setActive)
        return () => leaving.next()
    }, [])

    const { locale} = useContext(SettingsContext)
    return(
        <div 
            className={"nav-element-container-b"} 
            style={{
                backgroundColor: active ? '#191C25' : 'transparent',
            }}
            onClick={MenuController.toggle}>
            <FaBars />
            <span className="nav-menu-title">{locale.menu}</span>
        </div>
    )
}


